
export const CORRECTIVE_SUBSECTION_MODEL_JSON = {
  CORRECTION_FORM: "reportEvaluation"
}
